import React from 'react'
import Link from 'gatsby-link'
import PostGrid from '../components/PostGrid'

const IndexPage = ({data}) => (
  <div>
    <PostGrid data={data.posts} />
  </div>
)

export default IndexPage

export const query = graphql`
  query Posts {
    posts: allMarkdownRemark(
      limit: 12
      sort: { 
        fields: [frontmatter___date], 
        order: DESC 
      }
      filter: { 
        frontmatter: { 
          templateKey: { 
            eq: "BlogPostTemplate" 
          } 
        } 
      }
    ) {
      edges {
        node {
          id
          excerpt
          fields {
            slug
            hero {
              childImageSharp {
                resolutions(height: 240, width: 320) {
                  src
                  srcSet
                  width
                  height
                }
              }
            }
          }
          frontmatter {
            date(formatString: "YYYY")
            title
            category
          }
        }
      }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/index.js